<template>

  <div class="page-margin">

    <section class="auth-page request-page">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-6 request-left">
            <div class="auth-card">
              <div class="main">
                <div class="mb-4 text-left">
                  <h2>Schedule demo</h2>
                  <img
                    src="../assets/images/title-line.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <form class="auth-form">
                  <div class="form-group">
                    <label for="exampleInputname">Name</label>
                    <i class="fa fa-user"></i>
                    <input
                      required=""
                      name="loginname"
                      type="text"
                      class="form-control"
                      id="exampleInputname"
                      placeholder="Name"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputnumber">Company name</label>
                    <i class="fa fa-phone"></i>
                    <input
                      required=""
                      name="loginnumber"
                      type="text"
                      class="form-control"
                      id="exampleInputnumber"
                      placeholder="Company name"
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">Email</label>
                    <i class="fa fa-envelope-o"></i>
                    <input
                      required=""
                      name="login[username]"
                      type="email"
                      class="form-control"
                      id="exampleInputEmail1"
                      placeholder="Email"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword1">Phone number</label>
                    <i class="fa fa-lock"></i>
                    <input
                      id="exampleInputPassword1"
                      required=""
                      type="number"
                      class="form-control"
                      placeholder="Phone Number"
                    />
                  </div>
                  <div class="form-group mb-0 text-left">
                    <button
                      class="btn submit"
                      name="submit"
                      value="submit"
                      type="submit"
                    >
                      Schedule Demo
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-6 request-right">
            <div class="home-right">
              <div class="mobile-slid mt-0">
                <img
                  src="../assets/images/top-mobile.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="profile-msg">
                <img
                  src="../assets/images/top2.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
              <div class="awesome">
                <img
                  src="../assets/images/top3.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="profile-1">
                <img
                  src="../assets/images/top4.png"
                  alt="top4"
                  class="img-fluid"
                />
              </div>
              <div class="emoji">
                <img
                  src="../assets/images/top5.png"
                  alt="top5"
                  class="img-fluid"
                />
              </div>
              <div class="profile-2">
                <img
                  src="../assets/images/top1.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
 
    <Copyright />

  </div>

</template>

<script>
import Copyright from "@/components/copy_right.vue";
export default {
  name: "Request",
  components:{
    Copyright
  },
  beforeCreate: function () {
    const path = this.$route.path; 
    if (path === "/chatloop/rtl/request") {
      document.body.className = "inner-page rtl";
    } else {
      document.body.className = "inner-page";
    }
  },
};
</script>
